var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};

// src/SlateReactPresentation.tsx
import React from "react";

// src/utils.ts
import { isPlainObject } from "is-plain-object";
function isElement(value) {
  return isPlainObject(value) && "children" in value && Array.isArray(value.children);
}

// src/SlateReactPresentation.tsx
import { jsx } from "react/jsx-runtime";
var SlatePresentationContext = React.createContext(null);
function useSlatePresentation() {
  return React.useContext(SlatePresentationContext);
}
function Element({ element = { children: [] } }) {
  const { renderElement } = useSlatePresentation();
  return /* @__PURE__ */ jsx(React.Fragment, { children: renderElement == null ? void 0 : renderElement({ attributes: {}, children: /* @__PURE__ */ jsx(Children, { children: element.children }), element }) });
}
function Leaf({ leaf = { text: "" } }) {
  const { renderLeaf, LeafWrapper } = useSlatePresentation();
  return /* @__PURE__ */ jsx(React.Fragment, { children: renderLeaf == null ? void 0 : renderLeaf({ attributes: {}, children: /* @__PURE__ */ jsx(LeafWrapper, { children: leaf.text }), leaf, text: leaf }) });
}
function Children({ children = [] }) {
  return /* @__PURE__ */ jsx(React.Fragment, { children: children.map((child, i) => {
    if (isElement(child)) {
      return /* @__PURE__ */ jsx(Element, { element: child }, i);
    } else {
      return /* @__PURE__ */ jsx(Leaf, { leaf: child }, i);
    }
  }) });
}
function SlateReactPresentation(props) {
  const {
    value = [],
    renderElement = (props2) => /* @__PURE__ */ jsx(DefaultElement, __spreadValues({}, props2)),
    renderLeaf = (props2) => /* @__PURE__ */ jsx(DefaultLeaf, __spreadValues({}, props2)),
    LeafWrapper = "span"
  } = props;
  return /* @__PURE__ */ jsx(SlatePresentationContext.Provider, { value: { renderElement, renderLeaf, LeafWrapper }, children: /* @__PURE__ */ jsx(Children, { children: value }) });
}
function DefaultElement({ children }) {
  return /* @__PURE__ */ jsx("div", { children });
}
function DefaultLeaf({ children }) {
  return /* @__PURE__ */ jsx("span", { children });
}
export {
  SlateReactPresentation
};
//# sourceMappingURL=index.mjs.map